import { storage } from '@/components/Storage.js';

export const cache = {
    get: function () {
        return storage.cache ?? [];
    },
    push: function (data) {
        const items = this.get();
        items.push(data);
        storage.cache = JSON.stringify(items);
    },
    sync: function () {
        const items = this.get();
        if (items.length > 0) {
            m.request({
                method: 'POST',
                url: '/api/sync',
                background: true,
                data: items
            }).then(function () {
                storage.cache = JSON.stringify([]);
            }, function () {
                storage.cache = JSON.stringify([]);
            });
        }
    }
};
